module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image29.202cf07b.webp";